import { gatewayInstance } from "../../axiosInstance";

export const invoiceSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/ev-inv-generator/invoice-search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const evInvApprovalSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/ev-inv-generator/ev-inv-approval-search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const getInvoiceById = async (eihid) => {
  try {
    const response = await gatewayInstance.get(
      `financeservice/ev-inv-generator/by-id/${eihid}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getAdHocInvoiceById = async (eihid) => {
  try {
    const response = await gatewayInstance.get(
      `financeservice/ev-inv-generator/ad-hoc/by-id/${eihid}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const getInvoiceByJobId = async (jobId, type) => {
  try {
    const response = await gatewayInstance.get(
      `financeservice/ev-inv-generator/get-by-job/${jobId}/${type}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateInvoiceById = async (data) => {
  const response = await gatewayInstance.put(
    `financeservice/ev-inv-generator/update-invoice`,
    data,
  );
  return response.data;
};

export const evInvDelete = async (data) => {
  const response = await gatewayInstance.post(
    `financeservice/ev-inv-generator/delete-ev-inv`,
    data,
  );
  return response;
};
